import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react"
import reducer, { StoreState, initialState } from "./reducer"
import { StoreAction } from "../../../types/store"

interface StoreContext {
  statePlayer: StoreState
  dispatchPlayer: Dispatch<StoreAction>
}

export const Store = createContext<StoreContext>({
  statePlayer: initialState,
  dispatchPlayer: () => undefined,
})

export function useStorePlayer(): StoreContext {
  return useContext(Store)
}

interface Props {
  children: ReactNode | ReactNode[]
}

export function StoreProviderPlayer({ children }: Props) {
  const [statePlayer, dispatchPlayer] = useReducer(reducer, initialState)

  return <Store.Provider value={{ statePlayer, dispatchPlayer }}>{children}</Store.Provider>
}
